import { defineComponent as _defineComponent } from 'vue'
import { ref, toRef, computed } from 'vue';
import { ProductTileImage } from './ProductTile.vue';
import { useSwiper, ManagedSwiper, SwiperPagination, SwiperNavigationButton } from '@/ui/shared/swiper';
import AutoOptimizedImage from '@/ui/shared/image/auto-optimized-image/AutoOptimizedImage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductTileImageCarousel',
  props: {
    images: null,
    url: { default: undefined },
    backgroundColor: { default: 'transparent' },
    isEmptyProduct: { type: Boolean }
  },
  emits: ['image-loaded', 'image-load-error', 'focus-sync'],
  setup(__props: any, { emit }) {

const props = __props as { images: ProductTileImage[], url: string | undefined, backgroundColor: string, isEmptyProduct?: boolean }



const isSwiperFocused = ref(false);



const { swiperManager } = useSwiper<ProductTileImage>({
    slides: toRef(props, 'images'),
    swiperOptions: {
        direction: 'horizontal',
        loop: true,
        roundLengths: true,
        spaceBetween: 1
    }
});

const imageErrored = ref<boolean>(false);

const handleImageLoad = (index: number) => {
    if (index === 0) {
        emit('image-loaded');
    }
};
const handleImageLoadError = (index: number) => {
    imageErrored.value = true;
    if (index === 0) {
        emit('image-load-error');
    }
};

function handleFocus(focusEvent: boolean) {
    emit('focus-sync', focusEvent);
    isSwiperFocused.value = focusEvent;
}


return { __sfc: true,emit, isSwiperFocused, props, swiperManager, imageErrored, handleImageLoad, handleImageLoadError, handleFocus, ManagedSwiper, SwiperPagination, SwiperNavigationButton, AutoOptimizedImage }
}

})